module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bDzDO"))).then(() => module.bundle.root('d181N'));